/**
 * 判断当前页面是否在 Kamis 环境中
 *
 * @returns {boolean} 如果在 Kamis 环境中返回 true，否则返回 false
 * @example
 * ```ts
 * import { isInKamis } from 'matrix-js';
 *
 * if (isInKamis()) {
 *   // 在 Kamis 环境中的逻辑
 * } else {
 *   // 非 Kamis 环境中的逻辑
 * }
 * ```
 */
export function isInKamis(): boolean {
  try {
    // 检查是否存在 __KAMIS_JSONP_KEY 变量
    const hasKamisKey =
      typeof window !== "undefined" && "__KAMIS_JSONP_KEY" in window;

    // 检查 URL 是否包含 kamis-renderer
    const hasKamisRenderer =
      typeof window !== "undefined" &&
      window?.location?.href?.includes("kamis-renderer");

    return hasKamisKey || hasKamisRenderer;
  } catch (error) {
    // 出现异常时返回 false，确保函数的健壮性
    return false;
  }
}
